<template>
  <div class="breadcrumb" aria-label="Breadcrumb" role="navigation">
    <div class="breadcrumb-content">
      当前位置：
      <svg class="breadcrumb-svgicon" aria-hidden="true">
        <use xlink:href="#icon-home"></use>
      </svg>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyBreadcrumb",
  props: {
    separator: {
      type: String,
      default: "/"
    },
    separatorClass: {
      type: String,
      default: ""
    }
  },
  provide() {
    return {
      myBreadcrumb: this
    };
  },
  mounted() {
    const items = this.$el.querySelectorAll(".el-breadcrumb__item");
    if (items.length) {
      items[items.length - 1].setAttribute("aria-current", "page");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/common/breadcrumb/breadcrumb.vue